import SurveysIncludedQuestionsForm from 'src/javascripts/components/surveys/SurveysIncludedQuestionsForm';
import Questions from 'src/javascripts/components/surveys/Questions'

export default class SurveysQuestionsNew {

  constructor() {}

  render() {

  	Questions();
    SurveysIncludedQuestionsForm();

  }

}